/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CheckOutAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Children from 'Simple/Children'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function CheckOutAction({
  children,
  viewPath = "/DesignSystem/CheckOutAction",
  onSubmit,
  isSubmitting
  
}) {
let checkOutSubmitData = fromData.useDataSubmit({ viewPath,
context: 'check_out',
})
let checkOutIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'check_out',
})
  return (<React.Fragment
>
<Children
  viewPath={`${viewPath}/Children`}
 data="check_out"
 onClick={checkOutSubmitData}
 disabled={checkOutIsSubmittingData}
>
{children}
</Children>
</React.Fragment>)
}